
import "./App.css";
import { SearchArea } from "./components/SearchArea";


function App() {
  
  return (
    <div className="App">
        <SearchArea/>
    </div>
  );
}

export default App;
